/**
 * Three steps between filling the form and going live.
 *
 * `visual` picks the small illustration drawn on each step in HowItWorks.vue.
 */

export const howItWorks = [
  {
    step: "01",
    visual: "form",
    title: "משאירים פרטים",
    text: "שם, שם הסטודיו ומספר טלפון. זה כל מה שצריך כדי להתחיל.",
  },
  {
    step: "02",
    visual: "setup",
    title: "מקימים את הסטודיו",
    text: "אנחנו בונים את הלו״ז, סוגי האימונים, הקבוצות והמנויים לפי איך שהסטודיו שלכם עובד — ומעלים אפליקציה עם המותג שלכם.",
  },
  {
    step: "03",
    visual: "booked",
    title: "המתאמנות נרשמות לבד",
    text: "המתאמנות מורידות את האפליקציה ונרשמות לאימונים בעצמן. אתם רואים לו״ז מלא ומסודר.",
  },
];
